import TYPES from '../../types';

// Domain
import { InvestorProfileInvestmentExperienceRepository }
  from '../../domain/repositories/investor-profile-investment-experience-repository';
import { InvestorProfileInvestmentExperienceDto }
  from '../../domain/dtos/investor-profile-investment-experience-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Command from '@/modules/shared/domain/use-cases/command';

@Injectable()
export default class UpdateInvestorProfileInvestmentExperienceCommand
  extends Command<InvestorProfileInvestmentExperienceDto> {
  @Inject(TYPES.INVESTOR_PROFILE_INVESTMENT_EXPERIENCE_REPOSITORY)
  private readonly repository!: InvestorProfileInvestmentExperienceRepository;

  internalExecute(payload: InvestorProfileInvestmentExperienceDto): Promise<void> {
    return this.repository.update(payload);
  }
}
